import createReducer from 'utils/createReducer';

// Initial State
const INIT_STATE = {
  loading: true,
};

// Actions
const SET_LOADING = 'app/SET_LOADING';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_LOADING](state, action) {
    return {
      ...state,
      loading: action,
    };
  },
});

// Action creators
export const loading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});
